export default "__VITE_ASSET__DYh_pPCV__"